export default __webpack_public_path__ + "static/media/gold 2 c.83f88d98.png";